import { useContext, useEffect, useState } from "react";
import PopUp from "../PopUp";
import { useAppStore } from "../../store/useAppStore";
import { AppContext } from "../../App";
import api from "../api/api";

export default function GloryPopup() {
	const { setConfirm, sendLocalCommand } = useContext(AppContext);
	const { glory, cashPaymentPopup } = useAppStore();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		console.log("glory set to", glory, cashPaymentPopup);
		if (glory && !cashPaymentPopup && (glory.status_code != 1 || glory.cassette == 0))
			setVisible(true);
		else setVisible(false);
	}, [glory, cashPaymentPopup]);

	const hadleReset = async (command) => {
		console.log("hadleReset", command);

		setConfirm({
			title: "Sei sicuro?",
			onConfirm: async () => {
				const response = await api.postProtected("/glory/edit/" + glory.id + "/", {
					status_code: 1,
				});
				if (response.success == 0) alert(response.error);
				const res = await sendLocalCommand("resetRequest", { glory_id: glory.id });
				console.log(res);
			},
		});
	};

	if (!visible) return null;

	return (
		<PopUp
			customClass="glory-popup"
			options={{
				size: "small",
				title: "Glory",
				onClose: false,
			}}
		>
			<div className="inner-content">
				<h3>Stato: {glory.status}</h3>
				<h3>Valigia: {glory.cassette == 1 ? "Presente" : "Assente"}</h3>
				<div className="buttons-group">
					{(glory.status_code == 13 || glory.status_code == 30) && (
						<button onClick={() => hadleReset()} className="button">
							Reset
						</button>
					)}
					<button
						onClick={() => sendLocalCommand("statusRequest", { glory_id: glory.id })}
						className="button"
					>
						Aggiorna stato
					</button>
				</div>
			</div>
		</PopUp>
	);
}
